export default __webpack_public_path__ + "static/environmental-mobile-banner-d2e75330959298a3a2ce069fc12f7d4c.png";